(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'application',
            url: '/settings',
            data: {
                authorities: [],
                pageTitle: 'Ustawienia konta  - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
